





























import { PDFDocumentProxy, TypedArray } from 'pdfjs-dist/types/src/display/api';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
// import PDFJS from 'pdfjs-dist';
import * as PDFJS from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { warn } from 'vue-class-component/lib/util';
import { limitCanvasLongSide } from '@/utils';
PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
// PDFJS.GlobalWorkerOptions.workerSrc = 'pdfjs-dist/build/pdf.worker.js';

export enum ViewFileType {
  pdf = 0,
  img = 1,
}

@Component
export default class UploadPreview extends Vue {
  // step 1: 获取文件列表
  @Prop({ type: Number, default: ViewFileType.pdf })
  public inputFileType?: ViewFileType;

  @Prop({ default: null})
  public inputFileList?: FileList;

  // step 2: 按 文件类型 解析为 对应 暂存格式
  /**
   * pdf文件 读取后 存放的地方
   * pdf文档代理 可以调用相关方法获得pdf文件的信息
   */
  public pdfDoc: PDFDocumentProxy | null = null;

  /**
   * img文件 读取后 存放的地方
   */
  public imgFileList: string[] = [];

  // step 3 获取 可见渲染的页面数量,实际不会 超过总页数
  @Prop({ type: Number, default: 100 })
  public defaultVisibleRenderNumPages!: number;

  // step 4: 获取 可见渲染起始页面 的 页码
  @Prop({ type: Number, default: 1/* start from 1 */ })
  public startPageNum!: number;

  public defaultMaxRenderNumPages: number = 100;

  @Prop({ type: Number, default: 0})
  public rotateDegree: number = 0;

// **** step 1 读取文件
  public resetData() {
    this.pdfDoc = null;
    this.imgFileList = [];
  }

  @Watch('inputFileList', { deep: true })
  public changeFileList(newVal) {
    this.resetData();
    const inputFileList = this.inputFileList;
    if ( inputFileList && this.inputFileType === ViewFileType.pdf) {
      const pdfFile = inputFileList[0];
      this.readPdf(pdfFile);
    } else if ( inputFileList && this.inputFileType === ViewFileType.img) {
      this.readImgList(inputFileList);
    } else {
      warn('变更 FileList 失败!');
    }
  }

  /**
   * 从 `File` 中读取PDF保存到 `this.pdfDoc`
   */
  public readPdf(file: File) {
     // Step 1: Read the file using file reader
    const fileReader = new FileReader();
    const that = this;
    fileReader.onload = function() {
        // Step 2:turn array buffer into typed array
        const fileResult = this.result;
        const typedarray = new Uint8Array(fileResult as any);
        // Step 3:pdfjs should be able to read this
        PDFJS.getDocument(typedarray).promise.then((p) => {
          that.pdfDoc = p;
        });
    };
    // Step 4:Read the file as ArrayBuffer
    fileReader.readAsArrayBuffer(file);
  }

  /**
   * 从 `FileList` 中读取PDF保存到 `this.imgFileList`
   */
  public readImgList(inputFileList: FileList) {
    const readImg = (file: File, resultList: string[], resolve: (value: string) => void, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = function() {
        const fileResult = this.result;
        resolve(fileResult as string);
        resultList.push(fileResult as string);
      };
      fileReader.onerror = function() {
        reject(this.error);
      };
      fileReader.readAsDataURL(file);
    };
    // readImg 会写入 this.imgFileList , 使用前需要清空
    this.imgFileList.splice(0, this.imgFileList.length);
    const promises = Array.from(inputFileList)
      .map((file) => new Promise<string>((resolve, reject) => readImg(file, [], resolve, reject)));
    // 等待所有img都 load 完成后, 再更新imgFileList 触发下一步的渲染
    Promise.all(promises)
      .then((arr) => this.imgFileList = (arr as string[]));
  }

// **** step 2 读取文件后
  /**
   * 当前打开文件的 实际总页数
   */
  get numPages() {
    const numPages = (this.inputFileType === ViewFileType.pdf && this.pdfDoc?.numPages)
      || (this.inputFileType === ViewFileType.img && this.imgFileList.length)
      || 0;
    this.updateNumPages(numPages);
    return numPages;
  }

  @Emit('update:numPages')
  public updateNumPages(v) { return v; }

  get renderNumPages() {
    return Math.min(this.defaultMaxRenderNumPages, this.numPages);
  }

  get canvasIdArr(): string [] {
    const intArr0toRenderNumPages = [...Array(this.renderNumPages).keys()];
    return intArr0toRenderNumPages
      .map((v) => `preview-canvas-${v}`);
  }

  get visibleRenderNumPages() {
    return Math.min(this.defaultVisibleRenderNumPages, this.renderNumPages);
  }

  get startIndex() {
    return this.startPageNum - 1;
  }
// **** step 3 渲染

  @Watch('pdfDoc')
  public updateRenderByPdfDoc(newVal, oldVal) {
    if (newVal) {
      this.renderPdf(1, this.renderNumPages).then((e) => {
        this.updateCanvasArr();
      });
    }
  }

  /**
   * @param startPageNum — The page number to get. The first page is 1.
   */
  public async renderPdf(startPageNum: number, renderNumPages: number) {
    const promises: Array<Promise<any>> = [];
    const renderPage = (i/* start from 0 */: number) => {
      const canvasId = this.canvasIdArr[i];
      promises.push(this.renderSinglePdf(this.pdfDoc, startPageNum + i, canvasId));
    };
    for (let i = 0; i < renderNumPages; i++) {
      renderPage(i);
    }
    return Promise.all(promises);
  }

  /**
   * pdf 单页渲染
   * @param pdfDoc - PDFDocumentProxy
   * @param pageNumber — The page number to get. The first page is 1.
   * @param canvasId - string - `canvasId` to get HTMLCanvasElement
   */
  public async renderSinglePdf(pdfDoc: PDFDocumentProxy | null, pageNumber: number, canvasId: string) {
    if (pdfDoc) {
      const page = await pdfDoc.getPage(pageNumber);
      // 设置设备像素比
      const dpr = (window.devicePixelRatio || 1);
      // 设置展示比例
      const scale = 1.5 * dpr;
      // var scale = 1;
      // 获取pdf尺寸
      const viewport = page.getViewport({scale});
      // 获取需要渲染的元素
      const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
      const context = (canvas as any).getContext('2d');
      (canvas as any).height = viewport.height;
      (canvas as any).width = viewport.width;
      const renderContext = {
          canvasContext: context,
          viewport,
      };
      return page.render(renderContext).promise;
    }
    return Promise.reject();
  }

  @Watch('imgFileList', { deep: true })
  public async updateRenderByImgFileList(newVal) {
    if (newVal && newVal.length > 0) {
      await this.renderImgList(1, this.renderNumPages);
      this.updateCanvasArr();
    }
  }

  public async renderImgList(startPageNum: number, renderNumPages: number) {
    const renderPage = async (i/* start from 0 */: number) => {
      const canvasId = this.canvasIdArr[i];
      return await this.renderSingleImg(this.imgFileList![startPageNum - 1 + i], canvasId);
    };
    const promises: Array<Promise<boolean>> = [];
    for (let i = 0; i < renderNumPages; i++) {
      promises.push(renderPage(i));
    }
    return Promise.all(promises);
  }

  public async renderSingleImg(img: string, canvasId: string) {
    return new Promise<boolean>((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
        canvas.width = image.width;
        canvas.height = image.height;
        canvas.getContext('2d')?.drawImage(image, 0, 0);
        limitCanvasLongSide(canvas, 1500);
        resolve(true);
      };
      image.onerror = () => {
        reject('load image error');
      };
      image.src = img;
    });
  }

// **** step 4 返回渲染结果

  @Emit('updateCanvasArr')
  public updateCanvasArr() {
    const canvasArr: HTMLCanvasElement[] = [];
    this.canvasIdArr.map((canvasId) => {
      const canvas = document.getElementById(canvasId);
      if (canvas instanceof HTMLCanvasElement) {
        canvasArr.push(canvas);
      }
    });
    // console.log(canvasArr);
    return canvasArr;
  }

  @Emit('clickLeftTopBtn')
  public clickLeftTopBtn(i: number) {
    return i;
  }

  @Watch('rotateDegree')
  public rotateDegreeChanged(newRotateDegree: number) {
    console.log('newRotateDegree', newRotateDegree);
    const canRotate = newRotateDegree !== 0;
    if (canRotate) {
      const promises = this.canvasIdArr.map((canvasId) => {
        return new Promise<boolean>((resolve, reject) => {
          const canvas = document.getElementById(canvasId);
          if (canvas instanceof HTMLCanvasElement) {
            const b64img = canvas.toDataURL('image/jpeg', 1.0);
            const img = new Image();
            img.onload = () => {
              const w = canvas.height;
              const h = canvas.width;
              canvas.width = w;
              canvas.height = h;
              const x = w / 2;
              const y = h / 2;
              const ctx = canvas.getContext('2d');
              ctx?.translate(x, y);
              ctx?.rotate( 0.5 * Math.PI);
              ctx?.translate(-y, -x);
              ctx?.drawImage(img, 0, 0);
              resolve(true);
            };
            img.src = b64img;
          }
        });
      });
      Promise.all(promises)
      .then(() => {
        this.updateCanvasArr();
      });
    }
  }
}
